export default __webpack_public_path__ + "static/Jesse-high-7-0fc43ed7cab859736da383bf92b2a6d3.jpg";